
import { Injectable } from '@angular/core';
import { LocalStoreManager } from './local-store-manager.service';
import { DBkeys } from '../db-Keys';
import { Utilities } from '../helpers/utilities';
import { environment } from '@env/environment';

@Injectable()
export class ConfigurationService {

      public static readonly appVersion: string = '1.0.1';
    // ***Specify default configurations here***
       public static readonly defaultLanguage: string = 'en';
       public static readonly defaultHomeUrl: string = '/';
       public static readonly defaultTheme: string = 'Default';
       public static readonly defaultShowDashboardStatistics: boolean = true;
       public static readonly defaultShowDashboardNotifications: boolean = true;
       public static readonly defaultShowDashboardTodo: boolean = false;
       public static readonly defaultShowDashboardBanner: boolean = true;
       public static readonly apiVersion: string ='1.0';
        
       // ***End of defaults***

       private _language: string = null;
       private _homeUrl: string = null;
       private _theme: string = null;
       private _showDashboardStatistics: boolean = null;
       private _showDashboardNotifications: boolean = null;
       private _showDashboardTodo: boolean = null;
       private _showDashboardBanner: boolean = null;


    public baseUrl = environment.baseUrl || Utilities.baseUrl();
    public authenticationUrl = environment.authorityUrl || Utilities.baseUrl();
    public smartSuffix = environment.smartSuffix;
    public healthSuffix = environment.healthSuffix;
    public lifeSuffix = environment.lifeSuffix;
    public loginUrl = environment.loginUrl;
    public fallbackBaseUrl = 'http://microsoft.com';

    constructor(private localStorage: LocalStoreManager) {
        this.loadLocalChanges();
    }



    private loadLocalChanges() {


        // if (this.localStorage.exists(DBkeys.HOME_URL))
        //     this._homeUrl = this.localStorage.getDataObject<string>(DBkeys.HOME_URL);

        // if (this.localStorage.exists(DBkeys.THEME))
        //     this._theme = this.localStorage.getDataObject<string>(DBkeys.THEME);

        // if (this.localStorage.exists(DBkeys.SHOW_DASHBOARD_STATISTICS))
        //     this._showDashboardStatistics = this.localStorage.getDataObject<boolean>(DBkeys.SHOW_DASHBOARD_STATISTICS);

        // if (this.localStorage.exists(DBkeys.SHOW_DASHBOARD_NOTIFICATIONS))
        //     this._showDashboardNotifications = this.localStorage.getDataObject<boolean>(DBkeys.SHOW_DASHBOARD_NOTIFICATIONS);

        // if (this.localStorage.exists(DBkeys.SHOW_DASHBOARD_TODO))
        //     this._showDashboardTodo = this.localStorage.getDataObject<boolean>(DBkeys.SHOW_DASHBOARD_TODO);

        // if (this.localStorage.exists(DBkeys.SHOW_DASHBOARD_BANNER))
        //     this._showDashboardBanner = this.localStorage.getDataObject<boolean>(DBkeys.SHOW_DASHBOARD_BANNER);
    }


    private saveToLocalStore(data: any, key: string) {
        setTimeout(() => this.localStorage.savePermanentData(data, key));
    }

    public clearLocalChanges() {

        this.localStorage.deleteData(DBkeys.LANGUAGE);
        this.localStorage.deleteData(DBkeys.HOME_URL);
        this.localStorage.deleteData(DBkeys.THEME);
        this.localStorage.deleteData(DBkeys.SHOW_DASHBOARD_STATISTICS);
        this.localStorage.deleteData(DBkeys.SHOW_DASHBOARD_NOTIFICATIONS);
        this.localStorage.deleteData(DBkeys.SHOW_DASHBOARD_TODO);
        this.localStorage.deleteData(DBkeys.SHOW_DASHBOARD_BANNER);

    }

    set homeUrl(value: string) {
        this._homeUrl = value;
        this.saveToLocalStore(value, DBkeys.HOME_URL);
    }
    get homeUrl() {
        if (this._homeUrl != null) {
            return this._homeUrl;
        }

        return ConfigurationService.defaultHomeUrl;
    }


}
